import MapView from 'react-native-maps';

export const Marker = MapView.Marker;
export default MapView;
